/* ═══════════════════════════════════════════
   IRONCLAD PROXIES — THEME JAVASCRIPT
   ═══════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  // ─── FILTER CHECKBOXES ───────────────────────
  document.querySelectorAll('.filter-checkbox').forEach(cb => {
    cb.addEventListener('click', () => cb.classList.toggle('checked'));
  });

  // ─── FILTER ACCORDION HEADERS ────────────────
  document.querySelectorAll('.filter-header').forEach(header => {
    header.addEventListener('click', () => {
      const body = header.nextElementSibling;
      const toggle = header.querySelector('span:last-child');
      if (!body) return;
      if (body.style.display === 'none') {
        body.style.display = 'block';
        if (toggle) toggle.textContent = '−';
      } else {
        body.style.display = 'none';
        if (toggle) toggle.textContent = '+';
      }
    });
  });

  // ─── FAQ ACCORDION ────────────────────────────
  document.querySelectorAll('.faq-question').forEach(q => {
    q.addEventListener('click', () => {
      const item = q.parentElement;
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ─── PRODUCT PAGE ACCORDIONS ─────────────────
  document.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', () => {
      const accordion = header.parentElement;
      accordion.classList.toggle('open');
    });
  });

  // ─── PRODUCT IMAGE GALLERY ────────────────────
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('.product-gallery');
      if (!gallery) return;
      const mainImg = gallery.querySelector('.product-main-img');
      const src = thumb.querySelector('img')?.src;
      if (mainImg && src) {
        mainImg.style.opacity = '0';
        setTimeout(() => { mainImg.src = src; mainImg.style.opacity = '1'; }, 200);
      }
      gallery.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // ─── VARIANT BUTTONS ─────────────────────────
  document.querySelectorAll('.variant-options').forEach(group => {
    group.querySelectorAll('.variant-btn:not(.sold-out)').forEach(btn => {
      btn.addEventListener('click', () => {
        group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
      });
    });
  });

  // ─── QTY CONTROLS ────────────────────────────
  document.querySelectorAll('.qty-control').forEach(ctrl => {
    const input = ctrl.querySelector('.qty-input');
    ctrl.querySelector('.qty-minus')?.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
      input.dispatchEvent(new Event('change'));
    });
    ctrl.querySelector('.qty-plus')?.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      input.value = val + 1;
      input.dispatchEvent(new Event('change'));
    });
  });

  // ─── ADD TO CART FLASH ────────────────────────
  document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const orig = this.textContent;
      this.textContent = '✓ Added to Cart';
      this.style.background = 'linear-gradient(135deg, #3d9e55, #2a6b3a)';
      setTimeout(() => {
        this.textContent = orig;
        this.style.background = '';
      }, 2000);
    });
  });

  // ─── CART LINE ITEM TOTALS ────────────────────
  function updateCartTotals() {
    let subtotal = 0;
    document.querySelectorAll('.cart-item').forEach(item => {
      const priceEl = item.querySelector('[data-unit-price]');
      const qtyInput = item.querySelector('.qty-input');
      const lineEl = item.querySelector('.cart-item-price');
      if (!priceEl || !qtyInput || !lineEl) return;
      const price = parseFloat(priceEl.dataset.unitPrice) || 0;
      const qty = parseInt(qtyInput.value) || 1;
      const line = price * qty;
      lineEl.textContent = '$' + line.toFixed(2);
      subtotal += line;
    });
    const subtotalEl = document.querySelector('[data-cart-subtotal]');
    const totalEl = document.querySelector('[data-cart-total]');
    if (subtotalEl) subtotalEl.textContent = '$' + subtotal.toFixed(2);
    if (totalEl) totalEl.textContent = '$' + subtotal.toFixed(2);
  }

  document.querySelectorAll('.cart-item .qty-input').forEach(input => {
    input.addEventListener('change', updateCartTotals);
  });

  // ─── CART ITEM REMOVE ─────────────────────────
  document.querySelectorAll('.cart-item-remove').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.cart-item');
      item.style.transition = 'opacity 0.3s';
      item.style.opacity = '0';
      setTimeout(() => { item.remove(); updateCartTotals(); }, 300);
    });
  });

});
